import { PublicClientApplication, BrowserCacheLocation } from '@azure/msal-browser';
import authConfig from '../config/auth.json';

// Determine whether MSAL should be enabled. Priority:
// 1. Vite env var `VITE_DISABLE_MSAL` (set to '1' or 'true' to disable)
// 2. `auth.json` optional flag `microsoftOAuth.enabled` (false to disable)
const envDisable = typeof import.meta !== 'undefined' && typeof (import.meta as any).env !== 'undefined' && ((import.meta as any).env.VITE_DISABLE_MSAL === '1' || (import.meta as any).env.VITE_DISABLE_MSAL === 'true');
const configDisable = ((authConfig as any)?.microsoftOAuth as any)?.enabled === false;
export const MSAL_ENABLED = !envDisable && !configDisable;

const msalConfig = {
  auth: {
    clientId: authConfig.microsoftOAuth.clientId,
    authority: authConfig.microsoftOAuth.authority,
    redirectUri: typeof window !== 'undefined' ? window.location.origin : undefined,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false,
  },
};

let _msalClient: PublicClientApplication;

if (MSAL_ENABLED) {
  _msalClient = new PublicClientApplication(msalConfig as any);
} else {
  // Provide a safe stub implementation so callers can still import `msalClient`.
  // Methods return rejected promises or safe defaults; this avoids runtime crashes
  // while making the disabled state explicit.
  const stub: Partial<PublicClientApplication> = {
    initialize: async () => Promise.resolve(),
    loginPopup: async () => Promise.reject(new Error('MSAL is disabled')),
    acquireTokenSilent: async () => Promise.reject(new Error('MSAL is disabled')),
    acquireTokenPopup: async () => Promise.reject(new Error('MSAL is disabled')),
    getAllAccounts: () => [],
  };
  _msalClient = stub as PublicClientApplication;
}

export const msalClient = _msalClient;

let initializedPromise: Promise<void> | null = null;

export const initializeMsal = (): Promise<void> => {
  if (!initializedPromise) {
    if (!MSAL_ENABLED) {
      initializedPromise = Promise.resolve();
    } else {
      initializedPromise = msalClient.initialize();
    }
  }
  return initializedPromise;
};
